<template>
    <div id="login" v-loading="loading" class="background-white relative">
    <div class="bg">
        <div class="left relative">
            <img src="./../../assets/img/login3.png" :style="css" class="bg1 absolute">
            <img src="./../../assets/img/logo.png" :style="css" class="bg2 absolute">
            <img src="./../../assets/img/login2.png" :style="css" class="bg3 absolute">
            <img src="./../../assets/img/login1.png" :style="css" class="bg4 absolute">
            <div class="system-describe absolute">
                <div class="title mb15">比价系统</div>
                <p>比价系统的一些说明比价系统的一些说明比价系统的一些说明比价系统的一些说明
                比价系统的一些说明比价系统的一些说明比价系统的一些说明比价系统的一些说明
                </p>
            </div>
        </div>
        <div class="right relative">
            <div class="content absolute pt24">
                <div class="from absolute background-white">
                    <p class="title text-left">登录</p>
                    <div class="pl30 pr24 pb30 relative">
                        <el-input v-model="data.name" class="login-text" @keyup.enter.native="sign()" placeholder="用户名"><i slot="prefix"><img class="prefix absolute" src="./../../assets/img/username.png"></i></el-input>
                    </div>
                    <div class="pl30 pr24 pb20 relative">
                        <el-input v-model="data.password" class="login-text" type="password" @keyup.enter.native="sign()" placeholder="密码"><i slot="prefix"><img class="prefix absolute" src="./../../assets/img/password.png"></i></el-input>
                    </div>
                    <div class="pl30 pr24">
                        <el-checkbox v-model="isRemember" >记住我的登录状态</el-checkbox>
                    </div>
                    <div class="pl30 pr20 login-btn">
                        <el-button type="primary" @click="sign()">登录</el-button>
                    </div>
                    <img src="./../../assets/img/login4.png" :style="css" class="bg5 absolute">
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data () {
    return {
        data: {
            name: '',
            password: '',
            code: ''
        },
        isRemember: false,
        css: {},
        loading: false,
        verifyCode: null
    }
    },
    watch: {
        isRemember (val) {
            if (val) {
              //记住登录账号及密码
                sessionStorage.setItem('account',this.data.name);
                sessionStorage.setItem('password',this.data.password);
            } else {
              //取消
                sessionStorage.removeItem('account');
                sessionStorage.removeItem('password');
            }
        },
    },
    methods:{
    sign() {
        if (this.data.name.length === 0) {
            this.error('请输入账号')
            return
        }
        if (this.data.password.length === 0) {
            this.error('请输入密码')
            return
        }
        let options = {
            account: this.data.name,
            password: this.md5(this.data.password)
        }
        this.loading = true;
        let dataList = [
            // {
            //     title: '主页', isShow: true, active: false, id: 'main',
            //     item:[],
            // },
            {
                title: '用户管理', isShow: true, active: true, id: 'user',
                item:[{
                    title: '用户管理', isShow: true, active: true, id: 'userManage',
                    item:[{
                        title: '商家列表', isShow: true, active: true, id: 'userList', url: '/userList'
                    },{
                        title: '分组管理', isShow: false, active: true, id: 'groupManage', url: '/groupList'
                    }]
                }],
            }, {
                title: '数据分析', isShow: true, active: false, id: 'dataAnalysis',
                item:[{
                    title: '数据分析', isShow: true, active: true, id: 'dataAnalysis2',
                    item:[{
                        title: '查询记录', isShow: true, active: false, id: 'queryRecord', url: '/queryRecord'
                    },{
                        title: '商品库', isShow: true, active: false, id: 'commodityStore', url: '/commodityStore'
                    }]
                }],
            }, {
                title: '自动比价', isShow: true, active: false, id: 'automaticParity',
                item:[{
                    title: '自动比价', isShow: true, active: true, id: 'automaticParity2',
                    item:[{
                        title: '比价记录', isShow: false, active: true, id: 'parityRecord', url: '/parityRecord'
                    },{
                        title: '数据库连接信息', isShow: false, active: false, id: 'databaseConnectionIfo', url: '/databaseConnectionIfo'
                    }]
                }],
            }, {
                title: '网站导航', isShow: true, active: false, id: 'pcNavigation',
                item:[{
                    title: '网站导航', isShow: true, active: true, id: 'pcNavigation2',
                    item:[{
                        title: '导航管理', isShow: false, active: true, id: 'navManage', url: '/navManage'
                    },{
                        title: '导航分类', isShow: false, active: false, id: 'navType', url: '/navType'
                    }]
                }],
            }, {
                title: '用户建议', isShow: true, active: false, id: 'userSuggestions',
                item:[{
                    title: '用户建议', isShow: true, active: true, id: 'userSuggestions2',
                    item:[{
                        title: '平台建议', isShow: false, active: true, id: 'platformSuggestions', url: '/platformSuggestions'
                    },{
                        title: '商品建议', isShow: false, active: false, id: 'commoditySuggestions', url: '/commoditySuggestions'
                    },{
                        title: '软件建议', isShow: false, active: false, id: 'softwareSuggestions', url: '/softwareSuggestions'
                    },{
                        title: '错误反馈', isShow: false, active: false, id: 'errorBack', url: '/errorBack'
                    }]
                }],
            }, {
                title: '系统管理', isShow: true, active: false, id: 'system',
                item:[{
                    title: '用户建议', isShow: true, active: true, id: 'system2',
                    item:[{
                        title: '平台监管', isShow: false, active: true, id: 'platformSupervise', url: '/platformSupervise'
                    }]
                }],
            }
        ];
        this.$http('post', '/admin/login', {}, options, (statu, data) => {
            this.loading = false
            if (statu) {
                this.success('登录成功');
                sessionStorage.setItem('token', data.data.token);
                sessionStorage.setItem('loginInfo',JSON.stringify(data.data));
                this.$root.loginInfo = data.data;
                this.$root.Permission = dataList;
                sessionStorage.setItem('Permission', JSON.stringify(dataList))
                let url = dataList[0].item[0].item[0].url
                this.goPath(url)
            } else {
                this.data.code = ''
                this.getCode()
            }
        })
    },
    },
    mounted () {
        this.$root.openNav = [];
        let account = sessionStorage.getItem('account'),
            password = sessionStorage.getItem('password');
        if (!!account || !!password) {
            this.data.name = account;
            this.data.password = password;
            this.isRemember = true;
        }
    }
}
</script>

<style>
#login{width: 100%;height: 100vh;overflow: hidden;}
#login > .bg{height: 100%;}
#login  .content{height: 100%; width: 380px; left: -190px;}
#login  .content > .from{width: 380px;right: 0;top: 48%;transform: translateY(-50%);}
#login  .content > .from > .title{width: 100%;font-size: 20px; margin: 45px 0 40px 30px; font-weight: bold;}
#login  .content > .from .el-button{width: 100%;}
#login  .content > .from .verification-code{width: 88px;height: 34px;right: 23px;top: 3px;background: #CAE6FE;}
#login  .content > .from .prefix{left: 4px;top: 10px;}
#login .left{width: 70%; background: #EDF2FA; height: 100%;}
#login .right{width: 30%; background: #2480ED; height: 100%;}
#login  .login-btn{margin:79px 0 85px 0;}
#login  .login-text.el-input {width: 320px; border-radius: 0;}
#login .bg1 {left: 10%; top: 0;}
#login .bg2 {left: 25%; top: 8%;}
#login .bg3 {left: 25%; top: 25%;}
#login .bg4 {left: 15%; bottom: 0;}
#login .system-describe{width: 590px; left: 25%; top: calc(25% + 380px);}
#login .system-describe > .title{font-size: 20px; color: #0A1133; font-weight: bold;}
#login .system-describe p{font-size: 16px; color: #525A66; line-height: 25px; }
#login .bg5{left: calc(50% - 40px); bottom: -50px;}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue